import clsx, { ClassValue } from 'clsx';
import { FC, ReactNode } from 'react';
import ReactSelect from 'react-select';
import { ISelectOptions } from 'utils/models';
import CustomOption from './SelectOption';

interface ISelect {
  options: ISelectOptions[];
  value: any;
  onChange: (x: any) => void;
  label?: string;
  className?: ClassValue;
  placeholder?: string;
  icon?: ReactNode;
  round?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'r-2xl' | 'full';
  disabled?: boolean;
  isCustomOption?: boolean;
}

const customStyles = {
  option: (style: any, state: any) => {
    const customColors = {
      ...style,
      color: state.isDisabled ? '#9ca3af' : '#000000',
      cursor: state.isDisabled ? 'not-allowed' : 'default',
      backgroundColor: state.isFocused ? '#FCFD96' : '#ffffff',
      fontSize: '0.75rem',
      ':active': {
        ...style[':active'],
        backgroundColor: '#FCFD96'
      }
    };

    return customColors;
  }
};

const Select: FC<ISelect> = ({
  label,
  options,
  value,
  onChange,
  className,
  placeholder,
  icon,
  round = 'md',
  disabled = false,
  isCustomOption = false
}) => {
  const optionValue = options.find((item: ISelectOptions) => item.value === value);

  return (
    <div className={clsx(className)}>
      <div className={clsx((icon || label) && 'mb-3', 'flex items-center gap-2')}>
        {icon && icon}
        {label && <label className="text-sm">{label}</label>}
      </div>
      <ReactSelect
        styles={{
          ...customStyles,
          menu: (provided) => ({ ...provided, zIndex: 99999 }),
          menuPortal: (provided) => ({ ...provided, zIndex: 99999, position: 'fixed' })
        }}
        components={isCustomOption ? { Option: CustomOption } : undefined}
        options={options}
        onChange={(x) => onChange(x?.value)}
        value={optionValue}
        classNamePrefix="form-select"
        placeholder={placeholder}
        className={clsx('relative text-left form-select w-full', `round-${round}`)}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: '#dbeafe'
          }
        })}
        isDisabled={disabled}
        menuPlacement="auto"
        menuPortalTarget={document.getElementById('menu-portal')}
        menuShouldBlockScroll
      />
    </div>
  );
};

export default Select;
